<div class="modal-backdrop">
  <div class="modal-dialog-centered recipe-form-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Recipe' : 'Add Recipe' }}</h5>
        <button type="button" class="detail-close-btn" (click)="cancel()">✕</button>
      </div>

      <div class="modal-body">
        <label class="form-label">Name *</label>
        <input type="text" class="form-control mb-3" [(ngModel)]="form.name">

        <label class="form-label">Cuisine</label>
        <input type="text" class="form-control mb-3" [(ngModel)]="form.cuisine" placeholder="Mexican, Italian, American...">

        <label class="form-label">Feelings</label>
        <div class="chip-input-wrapper mb-3" (click)="feelingInputEl.focus()">
          <span class="chip feeling-chip" *ngFor="let tag of form.feelings">
            {{ tag }}
            <button type="button" (click)="removeFeeling(tag); $event.stopPropagation()">×</button>
          </span>
          <input #feelingInputEl type="text" class="chip-bare-input"
            [(ngModel)]="feelingInput"
            (keydown)="onFeelingKeydown($event)"
            [placeholder]="form.feelings.length === 0 ? 'comfort, hearty, refreshing...' : ''">
        </div>

        <label class="form-label">Ingredients</label>
        <div class="chip-input-wrapper mb-3" (click)="ingredientInputEl.focus()">
          <span class="chip ingredient-chip" *ngFor="let tag of form.ingredients">
            {{ tag }}
            <button type="button" (click)="removeIngredient(tag); $event.stopPropagation()">×</button>
          </span>
          <input #ingredientInputEl type="text" class="chip-bare-input"
            [(ngModel)]="ingredientInput"
            (keydown)="onIngredientKeydown($event)"
            [placeholder]="form.ingredients.length === 0 ? 'chicken, lemon, garlic...' : ''">
        </div>

        <label class="form-label">Link</label>
        <input type="url" class="form-control mb-3" [(ngModel)]="form.link" placeholder="https://...">

        <label class="form-label">Notes</label>
        <textarea class="form-control mb-3" [(ngModel)]="form.notes" rows="4" placeholder="Instructions, tips, variations..."></textarea>

        <div *ngIf="formError" class="alert alert-danger mt-2">{{ formError }}</div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
        <button class="btn btn-success" (click)="save()" [disabled]="saving">
          {{ saving ? 'Saving...' : (isEditMode ? 'Update Recipe' : 'Add Recipe') }}
        </button>
      </div>

    </div>
  </div>
</div>
